import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { rotaRetornoErro } from 'app/shared/utils/origem-navegacao.util';

@Component({
  selector: 'app-page404',
  standalone: false,
  templateUrl: './page404.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page404.component.css'
})
export class Page404Component {
  private readonly router = inject(Router);
  private readonly rota = inject(ActivatedRoute);

  readonly rotaRetorno = rotaRetornoErro(
    this.router,
    this.rota.snapshot.queryParamMap.get('origem')
  );
}
